import * as React from "react";
const SvgReorder = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m18.03 20.649 5.387-5.387a.75.75 0 0 0-1.06-1.06l-4.107 4.106V4.88a.75.75 0 0 0-1.5 0v13.427L12.643 14.2a.75.75 0 0 0-1.06 1.06l5.387 5.388a.747.747 0 0 0 1.048.013l.012-.013ZM5.97 3.351.583 8.738a.75.75 0 1 0 1.06 1.06L5.75 5.693V19.12a.75.75 0 0 0 1.5 0V5.692L11.357 9.8a.75.75 0 0 0 1.06-1.06L7.03 3.35a.753.753 0 0 0-1.06 0Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgReorder;
